import * as Yup from "yup";

const isStore = localStorage?.getItem("user_type") == "Store";

export const initialValues = (data, tags, approvalStatusOptions) => {
  const tagsArray = data?.tags?.split(", ");

  const selectedTags = tagsArray?.map((name) => {
    const item = tags.find((tag) => tag.name === name);
    return item && { label: name, value: item.id };
  });
  return {
    ...data,
    ...data?.localized_data,
    phone_number: `${data?.details?.country_code}${data?.details?.phone_number}`,
    country_code: data?.details?.country_code,
    image: data?.logo,
    email: data?.details?.email,
    google_cities_stores: data?.location,
    tags: data?.tag_details?.map((option) => {
      return {
        label: option?.name,
        value: option?.id,
      };
    }),
    is_verified: data?.details?.is_verified,
    is_email_verified: data?.details?.is_email_verified,
    profile_status: data?.details?.profile_status,
    cadeau_percentage: data?.cadeau_percentage,
    display_priority: data?.display_priority || "",
    is_featured: data?.is_featured || false,
  };
};

export let structure = (options, t) => {
  return [
    {
      head: "",
      width: "100%",
      list: [
        {
          name: `image`,
          kind: "upload",
          type: "image",
          label: t("vendors.label_upload_photo"),
          placeholder: "test",
          text: t("vendors.text_upload_photo_desc"),
          width: "47%",
        },
        {
          width: "47%",
        },
        {
          name: `en.name`,
          kind: "input",
          type: "text",
          label: `${t("vendors.label_vendor_name_en")}*`,
          width: "47%",
          placeholder: t("vendors.placeholder_vendor_name_en"),
        },
        {
          name: `ar.name`,
          kind: "input",
          type: "text",
          label: t("vendors.label_vendor_name_ar"),
          width: "47%",
          placeholder: t("vendors.placeholder_vendor_name_ar"),
        },
        {
          name: `email`,
          kind: "input",
          type: "text",
          label: t("vendors.label_email"),
          width: "47%",
          placeholder: t("vendors.placeholder_email"),
        },

        {
          name: `phone_number`,
          kind: "phone",
          type: "text",
          width: "47%",
          label: `${t("vendors.label_phone_number")}*`,
          placeholder: t("vendors.placeholder_phone_number"),
        },
        {
          name: `password`,
          kind: "input",
          type: "password",
          width: "47%",
          label: `${t("vendors.label_password")}*`,
          placeholder: "********",
        },
        {
          name: `password_confirmation`,
          kind: "input",
          type: "password",
          width: "47%",
          label: `${t("vendors.label_confirm_password")}*`,
          placeholder: "********",
        },

        {
          name: `tags`,
          kind: "multiSelect",
          type: "text",
          label: t("vendors.label_tags"),
          width: "47%",
          placeholder: t("vendors.placeholder_tag"),
          ...options?.tags,
        },
        {
          name: `profile_status`,
          kind: "select",
          type: "text",
          label: t("vendors.profile_status"),
          width: "47%",
          options: [
            { id: "approved", name: t("vendors.status_approved") },
            { id: "pending_approval", name: t("vendors.status_pending") },
            { id: "rejected", name: t("vendors.status_rejected") },
          ],
        },
        {
          name: `cadeau_percentage`,
          kind: "input",
          type: "number",
          label: t("vendors.label_cadeau_percentage"),
          width: "47%",
          placeholder: t("vendors.label_cadeau_percentage"),
        },

        {
          name: `display_priority`,
          kind: "input",
          type: "number",
          label: t("vendors.display_priority"),
          width: "47%",
          disabled: isStore,
        },
        {
          name: `is_featured`,
          kind: "checkbox",
          label: t("vendors.is_featured"),
          width: "fit-content",
          disabled: isStore,
        },
        {
          name: `is_verified`,
          kind: "checkbox",
          label: t("vendors.label_is_verified"),
          width: "fit-content",
          disabled: isStore,
        },
        {
          name: `is_email_verified`,
          kind: "checkbox",
          label: t("vendors.label_is_email_verified"),
          width: "fit-content",
          disabled: isStore,
        },
      ],
    },
  ];
};

export const validationSchema = (formikValues, id, t) =>
  Yup.object({
    email: Yup.string().email(t("vendors.error_email_invalid")),
    phone_number: Yup.number().required(t("vendors.error_required")),
    password:
      formikValues?.password_confirmation || !id
        ? Yup.string()
            .required(t("vendors.error_required"))
            .min(6, t("vendors.error_password_min"))
        : Yup.string().min(6, t("vendors.error_password_min")),
    password_confirmation:
      formikValues?.password || !id
        ? Yup.string()
            .required(t("vendors.error_required"))
            .oneOf(
              [Yup.ref("password"), null],
              t("vendors.error_passwords_mismatch"),
            )
        : Yup.string().oneOf(
            [Yup.ref("password"), null],
            t("vendors.error_passwords_mismatch"),
          ),
    en: Yup.object().shape({
      name: Yup.string().required(t("vendors.error_required")),
    }),
    //   name: Yup.string().required("Required"),
    // }),
    cadeau_percentage: Yup.number().nullable(),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
    is_featured: Yup.boolean(),
  });
